itsoftApp.createModule("focusVisible", function () {
    /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */
    /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
    const module = this;

    const FocusVisible = function () {
        this.path = "/assets/scripts/focus-visible/focus-visible.min.js";
        
        this.init();
    };

    FocusVisible.prototype.init = function () {
        itsoftApp.loadScript(this.path);
    };

    new FocusVisible();

    module.callback = FocusVisible;
});
